import React, { FC } from 'react'

import { TableBody } from '@style-port/roov-ui-components-react'
import { ApprovalRequestTableRow } from 'src/components/organisms/approvalRequests/ApprovalRequestTableRow'

import { MyReviewingConfirmationEntity } from 'src/types'

type Props = {
  myReviewingConfirmations: MyReviewingConfirmationEntity[]
  className?: string
}

export const ApprovalRequestTableBody: FC<Props> = ({ myReviewingConfirmations, className }) => {
  return (
    <TableBody className={className}>
      {myReviewingConfirmations.map(myReviewingConfirmation => (
        <ApprovalRequestTableRow
          key={myReviewingConfirmation.id}
          myReviewingConfirmation={myReviewingConfirmation}
        />
      ))}
    </TableBody>
  )
}
